import { PublicClientApplication } from '@azure/msal-browser';
import { msalConfig } from './authConfig';

const msalInstance = new PublicClientApplication(msalConfig);

// Initialize MSAL
export const initializeMSAL = async () => {
  try {
    await msalInstance.initialize(); // Ensure initialization
  } catch (error) {
    console.error("MSAL Initialization failed", error);
  }
};

export default msalInstance;